import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/straithub/arrow-right.png'


const _withScopeId = n => (_pushScopeId("data-v-41e00cd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "home-projects",
  class: "past-projects",
  "aria-labelledby": "past-projects-title"
}
const _hoisted_2 = { class: "past-projects__heading" }
const _hoisted_3 = { id: "past-projects-title" }
const _hoisted_4 = ["data-target-id", "onClick"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "past-projects__body" }
const _hoisted_7 = ["data-target-id"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "past-projects__arrow",
  src: _imports_0,
  alt: "",
  draggable: "false"
}, null, -1))
const _hoisted_9 = {
  class: "past-projects__group",
  "aria-hidden": "true"
}
const _hoisted_10 = ["data-target-id", "onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "past-projects__body" }
const _hoisted_13 = ["data-target-id"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "past-projects__arrow",
  src: _imports_0,
  alt: "",
  draggable: "false"
}, null, -1))

import {
  computed,
  nextTick,
  onActivated,
  onDeactivated,
  onMounted,
  onUnmounted,
  ref,
} from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const SCROLL_SPEED = 42;
const START_OFFSET = -52;


export default /*#__PURE__*/_defineComponent({
  __name: 'PastProjects',
  setup(__props) {

const router = useRouter();
const { locale } = useI18n();

const viewportRef = ref<HTMLElement | null>(null);
const trackRef = ref<HTMLElement | null>(null);
const groupRef = ref<HTMLElement | null>(null);
const offset = ref(START_OFFSET);
const groupWidth = ref(0);
const isHovering = ref(false);
const isDragging = ref(false);
const isReducedMotion = ref(false);

let resizeObserver: ResizeObserver | null = null;
let animationFrame = 0;
let lastFrameTime: number | undefined;
let suppressClick = false;
const dragState = {
  pointerId: null as number | null,
  startX: 0,
  startOffset: START_OFFSET,
  moved: false,
  targetId: "",
};

const copy = computed(() =>
  locale.value === "zh"
    ? { heading: "项目案例", explore: "了解更多" }
    : { heading: "Past Projects", explore: "Explore More" }
);

const projects = computed(() => {
  const isZh = locale.value === "zh";

  return [
    {
      targetId: "project-1",
      title: isZh ? "AI 服务器部署" : "AI Server Deployment",
      image: require("@/assets/straithub/past_projects/1-card.jpg"),
    },
    {
      targetId: "project-2",
      title: isZh ? "RDHx 液冷背门改造" : "RDHx Retrofit",
      image: require("@/assets/straithub/past_projects/2-card.jpg"),
    },
    {
      targetId: "project-3",
      title: isZh ? "数据中心负载测试" : "Data Center Load Bank Testing",
      image: require("@/assets/straithub/past_projects/3-card.jpg"),
    },
    {
      targetId: "project-5",
      title: isZh
        ? "AIDC 液冷二次侧一站式服务集成"
        : "AIDC Liquid Cooling Secondary Side One-Stop Service Integration",
      image: require("@/assets/straithub/past_projects/4-card.jpg"),
    },
    {
      targetId: "project-4",
      title: isZh ? "预制模块化数据中心" : "Prefabricated Modular Data Center",
      image: require("@/assets/straithub/past_projects/5.png"),
    },
  ];
});

const wrapOffset = (value: number) => {
  if (!groupWidth.value) return value;

  let next = value % groupWidth.value;
  if (next > 0) next -= groupWidth.value;
  return next;
};

const applyOffset = (value: number) => {
  offset.value = wrapOffset(value);
};

const measure = () => {
  groupWidth.value = groupRef.value?.offsetWidth || 0;
  applyOffset(offset.value);
};

const tick = (time: number) => {
  if (lastFrameTime === undefined) lastFrameTime = time;
  const delta = Math.min((time - lastFrameTime) / 1000, 0.064);
  lastFrameTime = time;

  if (!isReducedMotion.value && !isHovering.value && !isDragging.value) {
    applyOffset(offset.value - SCROLL_SPEED * delta);
  }

  animationFrame = window.requestAnimationFrame(tick);
};

const startAnimation = () => {
  if (animationFrame) return;
  lastFrameTime = undefined;
  animationFrame = window.requestAnimationFrame(tick);
};

const stopAnimation = () => {
  if (!animationFrame) return;
  window.cancelAnimationFrame(animationFrame);
  animationFrame = 0;
};

const navigateToProject = (targetId: string) => {
  router.push({ path: "/projects", hash: `#${targetId}` });
};

const handlePointerDown = (event: PointerEvent) => {
  if (
    !groupWidth.value ||
    (event.pointerType === "mouse" && event.button !== 0)
  ) {
    return;
  }

  const exploreButton = (event.target as Element | null)?.closest<HTMLElement>(
    "[data-target-id]"
  );

  dragState.pointerId = event.pointerId;
  dragState.startX = event.clientX;
  dragState.startOffset = offset.value;
  dragState.moved = false;
  dragState.targetId = exploreButton?.dataset.targetId || "";
  suppressClick = false;
  isDragging.value = true;
  viewportRef.value?.setPointerCapture?.(event.pointerId);
};

const handlePointerMove = (event: PointerEvent) => {
  if (!isDragging.value || dragState.pointerId !== event.pointerId) return;

  const distance = event.clientX - dragState.startX;
  if (Math.abs(distance) > 4) {
    dragState.moved = true;
    suppressClick = true;
  }
  applyOffset(dragState.startOffset + distance);
};

const endDrag = (event: PointerEvent) => {
  if (!isDragging.value || dragState.pointerId !== event.pointerId) return;

  const targetId = dragState.moved ? "" : dragState.targetId;

  viewportRef.value?.releasePointerCapture?.(event.pointerId);
  isDragging.value = false;
  dragState.pointerId = null;
  dragState.targetId = "";

  if (targetId) {
    suppressClick = true;
    navigateToProject(targetId);
    window.setTimeout(() => {
      suppressClick = false;
    }, 180);
    return;
  }

  if (dragState.moved) {
    window.setTimeout(() => {
      suppressClick = false;
    }, 180);
  }
};

const handleExplore = (targetId: string) => {
  if (suppressClick) return;
  navigateToProject(targetId);
};

onMounted(async () => {
  isReducedMotion.value = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;
  await nextTick();
  measure();

  if (typeof ResizeObserver !== "undefined" && groupRef.value) {
    resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(groupRef.value);
  } else {
    window.addEventListener("resize", measure);
  }

  startAnimation();
});

onActivated(startAnimation);
onDeactivated(stopAnimation);

onUnmounted(() => {
  stopAnimation();
  resizeObserver?.disconnect();
  window.removeEventListener("resize", measure);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(copy.value.heading), 1)
    ]),
    _createElementVNode("div", {
      ref_key: "viewportRef",
      ref: viewportRef,
      class: _normalizeClass(["past-projects__viewport", { 'is-dragging': isDragging.value }]),
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isHovering.value = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHovering.value = false)),
      onPointerdown: handlePointerDown,
      onPointermove: handlePointerMove,
      onPointerup: endDrag,
      onPointercancel: endDrag
    }, [
      _createElementVNode("div", {
        ref_key: "trackRef",
        ref: trackRef,
        class: "past-projects__track",
        style: _normalizeStyle({ transform: `translate3d(${offset.value}px, 0, 0)` })
      }, [
        _createElementVNode("div", {
          ref_key: "groupRef",
          ref: groupRef,
          class: "past-projects__group"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (project) => {
            return (_openBlock(), _createElementBlock("article", {
              key: project.targetId,
              class: "past-projects__card",
              "data-target-id": project.targetId,
              onClick: ($event: any) => (handleExplore(project.targetId))
            }, [
              _createElementVNode("img", {
                class: "past-projects__image",
                src: project.image,
                alt: project.title,
                draggable: "false"
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h3", null, _toDisplayString(project.title), 1),
                _createElementVNode("button", {
                  type: "button",
                  "data-target-id": project.targetId
                }, [
                  _createElementVNode("span", null, _toDisplayString(copy.value.explore), 1),
                  _hoisted_8
                ], 8, _hoisted_7)
              ])
            ], 8, _hoisted_4))
          }), 128))
        ], 512),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (project) => {
            return (_openBlock(), _createElementBlock("article", {
              key: `clone-${project.targetId}`,
              class: "past-projects__card",
              "data-target-id": project.targetId,
              onClick: ($event: any) => (handleExplore(project.targetId))
            }, [
              _createElementVNode("img", {
                class: "past-projects__image",
                src: project.image,
                alt: "",
                draggable: "false"
              }, null, 8, _hoisted_11),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h3", null, _toDisplayString(project.title), 1),
                _createElementVNode("button", {
                  type: "button",
                  tabindex: "-1",
                  "data-target-id": project.targetId
                }, [
                  _createElementVNode("span", null, _toDisplayString(copy.value.explore), 1),
                  _hoisted_14
                ], 8, _hoisted_13)
              ])
            ], 8, _hoisted_10))
          }), 128))
        ])
      ], 4)
    ], 34)
  ]))
}
}

})